import {
  UPDATE_EMPLOYEE,
  SET_EMPLOYEES,
  SET_ADMIN_EMPLOYEES,
  SET_TIME_CARDS,
  SET_ROLES,
  SET_INVITED_EMPLOYEES,
  SET_TIME_CARDS_ACTIVE,
} from '../types/employee'
import { saveSession, getSession } from '../utils/api'

const session = getSession()

const initState = {
  session,
  employees: [],
  adminsEmployees: [],
  timecards: [],
  roles: [],
  invitedEmployees: [],
  timecardsHistory: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case UPDATE_EMPLOYEE:
      saveSession(action.payload.session)
      return { ...state, session: action.payload.session }
    case SET_EMPLOYEES:
      return { ...state, employees: action.payload }
    case SET_ADMIN_EMPLOYEES:
      return { ...state, adminsEmployees: action.payload }
    case SET_TIME_CARDS:
      return { ...state, timecards: action.payload.timecards }
    case SET_ROLES:
      return { ...state, roles: action.payload.roles }
    case SET_INVITED_EMPLOYEES:
      return { ...state, invitedEmployees: action.payload.employees }
    case SET_TIME_CARDS_ACTIVE:
      return { ...state, timecardsHistory: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee.js